import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import { Ability } from '@casl/ability'
import { initialAbility } from './ability'

// Sets the initial ability
Vue.use(abilitiesPlugin, new Ability(initialAbility))
